import { FC, useContext, useState } from 'react';

import { Button, ExclamationIcon, H2, Modal } from '@smartshell/ui-kit';

import { clientsReloadTrigger } from 'index';
import { LocalizationContext } from 'localization';
import { ClientRegisterModal } from 'modals';
import { useNotCompleted } from 'modals/ClientRegisterModal/NotComletedContext';

import { INotCompletedRegisterProps } from './interfaces';
import s from './NotCompletedRegister.module.scss';

export const NotCompletedRegister: FC<INotCompletedRegisterProps> = ({
  client,
}) => {
  const { t } = useContext(LocalizationContext);
  const { removeClientById } = useNotCompleted();

  const [isVerificationContinue, setIsVerificationContinue] =
    useState<boolean>(false);
  const [onSuccess, setOnSuccess] = useState<boolean>(false);

  return (
    <>
      {onSuccess && (
        <Modal className={s.onSuccess}>
          <div className={s.header}>
            <H2>{t('clientRegister.modal.onSuccess.title')}</H2>
            <p className={s.onSuccess_text}>
              {t('clientRegister.modal.onSuccess.text', client?.phone)}
            </p>
          </div>
          <Button
            fullWidth
            onClick={() => {
              setOnSuccess(false);
              removeClientById(client.verifyClientId as number);
              clientsReloadTrigger(clientsReloadTrigger() + 1);
            }}
          >
            {t('ok')}
          </Button>
        </Modal>
      )}
      {isVerificationContinue && (
        <ClientRegisterModal
          onClose={() => {
            setIsVerificationContinue(false);
          }}
          client={client}
        />
      )}

      <div className={s.info}>
        <div className={s.icon}>
          <ExclamationIcon color="warning" size="m" />
        </div>

        <div className={s.info_block}>
          <p className={s.text}>
            <span>{t('workShifts.finish.byManager.notification.title')}</span>
            {t('notCompletedRegister.text', client.phone)}
          </p>
          <Button
            size="s"
            className={s.button}
            variant="outline"
            color="orange"
            onClick={() => {
              if (!client) return;
              setIsVerificationContinue(true);
            }}
          >
            {t('complete registration')}
          </Button>
        </div>
      </div>
    </>
  );
};
